<template>
  <v-card flat>
    <v-col cols="12" class="px-md-4">
      <v-card>
        <v-data-table
          :headers="headers"
          :items="provinces"
          item-key="name"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          class="accent"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              class="mx-4"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-card>
</template>

<script>
export default {
  props: {
    provinces: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    headers () {
      return [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Quantity',
          value: 'quantity',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    filterOnlyCapsText (value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search) !== -1
      )
    }
  }
}
</script>
